<div class="modal-header py-2 bg-dark text-light">
    <h4 class="modal-title">
        <i class="mdi mdi-car"></i>
        지오펜스설정정보
    </h4>
</div>

<div class="modal-body">
    <geofence-conf-list
        [listType]="DtgListType.modal"
        (confInfo)="callbackSelectConf($event)"></geofence-conf-list>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary btn-sm"
        (click)="clickCancel()">
        <i class="mdi mdi-close"></i>
        취소
    </button>
</div>